import React, { useState, useEffect } from 'react'
import { useSearchParams} from "react-router-dom";

import { DataGrid } from '@mui/x-data-grid';
import AddIcon from '@mui/icons-material/Add';
import { Grid, Typography, Button } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';

import DeleteNotification from '../../core/components/DeleteNotification';
import {CoreContext} from "../../core/context/CoreContext";
import PageWaiting from '../../core/components/PageWaiting';
import {isMobile} from 'react-device-detect';

import {getListAPI, deleteAPI} from './PharmaorderAPI';
import {getColumns} from './PharmaorderStruct';
import ListCardView from '../../core/components/card/ListCardView';
import ListTableView from '../../core/components/card/ListTableView';

import {getPharmaorderView} from './PharmaorderView';
import CardListLayout from '../../core/components/card/layout/CardListLayout';
import { useSelector, useDispatch } from 'react-redux';
import {setViewParams} from '../../store/slice/ChoiceSelectionSlice';

import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import ViewWeekIcon from '@mui/icons-material/ViewWeek';
import CalendarViewMonthIcon from '@mui/icons-material/CalendarViewMonth';

import {setFilter} from '../../store/slice/ConfSlice';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';
import MyPageContainer from '../../core/template/MyPageContainer';
import { deletePharmaorderObj  ,setSelectedPharmaorderId,setPharmaorderManageProductsModal,setPharmaorderEditorderModal,setPharmaorderDeleteorderModal,setPharmaorderAddproductModal,setPharmaorderVieworderModal,setPharmaorderApproveorderModal,setPharmaorderSubmitorderModal,setPharmaorderReferbackModal,setPharmaorderAddorderModal,setPharmaorderAccountsApprovalModal,setSelectedActionId , setShowEditForPharmaorder} from 'store/slice/PharmaSlice';

import PharmaorderListTable from './components/PharmaorderListTable';
import { useNavigate } from "react-router-dom";
import { setClickedBo,setActionClicked } from 'store/slice/BreadCrumSlice';
import PharmaorderFilterCriteria from './PharmaorderFilterCriteria';


import AddLinkIcon from '@mui/icons-material/AddLink';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import DeleteSweepIcon from '@mui/icons-material/DeleteSweep';
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import RuleIcon from '@mui/icons-material/Rule';
import SendIcon from '@mui/icons-material/Send';
import BackHandIcon from '@mui/icons-material/BackHand';
import AddCardIcon from '@mui/icons-material/AddCard';
import TaskAltIcon from '@mui/icons-material/TaskAlt';

import ManageProductsActionModal from './action/manageProducts/ManageProductsActionModal';
import EditorderActionModal from './action/editorder/EditorderActionModal';
import DeleteorderActionModal from './action/deleteorder/DeleteorderActionModal';
import AddproductActionModal from './action/addproduct/AddproductActionModal';
import VieworderActionModal from './action/vieworder/VieworderActionModal';
import ApproveorderActionModal from './action/approveorder/ApproveorderActionModal';
import SubmitorderActionModal from './action/submitorder/SubmitorderActionModal';
import ReferbackActionModal from './action/referback/ReferbackActionModal';
import AddorderActionModal from './action/addorder/AddorderActionModal';
import AccountsApprovalActionModal from './action/accountsApproval/AccountsApprovalActionModal';

import { transformDateValue } from 'core/js/FormUtils';
import { userprofileInfo } from 'store/slice/HeaderSlice';

export default function PharmaorderListImpl( {tableList, cardList, setShowEdit, setPharmaorderId}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { setNotification, setShowLoading, showloading, lastURL } = React.useContext(CoreContext);
  const columns = getColumns(editCallBack, initDeleteCallBack);
  const [view, setView] = useState(1);
  const { showfilter } = useSelector((state) => state.confslice)

  const [showDeleteAlert, setShowDeleteAlert] = useState(false);
  const {selectedId, pharmaorderObj} = useSelector((state)=>state.pharmaslice.pharmaorderDashboard);
  const { pharmaorderList } = useSelector((state) => state.pharmaslice.pharmaorderDashboard);
  const {userprofileInfo} = useSelector((state)=>state.headerslice);

  useEffect(() => {
  }, [pharmaorderList, pharmaorderObj])
  
  function initDeleteCallBack(id){
    dispatch(setSelectedPharmaorderId(id));
    setShowDeleteAlert(true);
  }
  function deleteCallBack(obj){
    dispatch(deletePharmaorderObj(obj.id));
    setNotification('Record deleted successfully !!!')
  }
  function deleteRecord(){
    deleteAPI(selectedId,deleteCallBack);
    setShowDeleteAlert(false);
  }

  function editCallBack(id){
    dispatch(setSelectedPharmaorderId(id));
    dispatch(setShowEditForPharmaorder(true));
  }
  
  const createPharmaorder=()=>{
    dispatch(setSelectedPharmaorderId(-1));
    //dispatch(setShowEditForPharmaorder(true));
    dispatch(setPharmaorderAddorderModal(true));
  }


  const manageProductsCallBack = (id) =>{
    dispatch(setSelectedPharmaorderId(id));
    //navigate('/pharmaorderpageeditproduct')
    dispatch(setPharmaorderManageProductsModal(true));
  }
  const editorderCallBack = (id) =>{
    dispatch(setSelectedPharmaorderId(id));
    dispatch(setPharmaorderEditorderModal(true));
  }
  const deleteorderCallBack = (id) =>{
    dispatch(setSelectedPharmaorderId(id));
    dispatch(setPharmaorderDeleteorderModal(true));
  }
  const addproductCallBack = (id) =>{
    dispatch(setSelectedPharmaorderId(id));
    dispatch(setPharmaorderAddproductModal(true));
  }
  const vieworderCallBack = (id) =>{
    dispatch(setSelectedPharmaorderId(id));
    dispatch(setPharmaorderVieworderModal(true));
  }
  const approveorderCallBack = (id) =>{
    dispatch(setSelectedPharmaorderId(id));
    dispatch(setPharmaorderApproveorderModal(true));
  }
  const submitorderCallBack = (id) =>{
    dispatch(setSelectedPharmaorderId(id));
    dispatch(setPharmaorderSubmitorderModal(true));
  }
  const referbackCallBack = (id) =>{
    dispatch(setSelectedPharmaorderId(id));
    dispatch(setPharmaorderReferbackModal(true));
  }
  const addorderCallBack = (id) =>{
    dispatch(setSelectedPharmaorderId(id));
    dispatch(setPharmaorderAddorderModal(true));
  }
  const accountsApprovalCallBack = (id) =>{
    dispatch(setSelectedPharmaorderId(id));
    dispatch(setPharmaorderAccountsApprovalModal(true));
  }

const getDataWithDateTransformation = (data) =>{
    let newData = {
      ...data,
      'expand':false,
    'dispatchdate': transformDateValue(data.dispatchdate)
    }
    return newData;
  }
  const pharmaorderTransformation = (tableList) =>{
    let newDataList=[]
    tableList.map((data)=>{ 
      newDataList.push(getDataWithDateTransformation(data));
     })
    return newDataList;
  }

  const payload = {
    pharmaorderList:pharmaorderList,
    cardList:getPharmaorderView(tableList),
        actionList: [
          /*{title:'Edit', callBackMethod:editCallBack, icon:<EditIcon/>, status:'NA'},
          {title:'Delete', callBackMethod:initDeleteCallBack, icon:<DeleteIcon/>, status:'NA'},
          
        {id:8, title:'Manage Products', callBackMethod:manageProductsCallBack, icon:<AddLinkIcon/>, status:'Draft, REFERED BACK', role:'PHARMA_OMS_SALES, PHARMA_OMS_MANAGER'},
        {id:12, title:'Edit Order', callBackMethod:editorderCallBack, icon:<BorderColorIcon/>, status:'NA', role:'PHARMA_OMS_SALES, PHARMA_OMS_MANAGER'},
        {id:20, title:'Delete Order', callBackMethod:deleteorderCallBack, icon:<DeleteSweepIcon/>, status:'Draft, REFERED BACK', role:'PHARMA_OMS_MANAGER'},
        {id:21, title:'Add Product', callBackMethod:addproductCallBack, icon:<PlaylistAddIcon/>, status:'NA', role:''},
        {id:22, title:'View Order', callBackMethod:vieworderCallBack, icon:<RemoveRedEyeIcon/>, status:'Draft, PLANNING, UNDER APPROVAL, REFERED BACK', role:''},
        {id:23, title:'Approve Order', callBackMethod:approveorderCallBack, icon:<RuleIcon/>, status:'MD Approval', role:'PHARMA_OMS_MD'},
        {id:26, title:'Submit Order', callBackMethod:submitorderCallBack, icon:<SendIcon/>, status:'NA', role:''},
        {id:27, title:'Refer Back Order', callBackMethod:referbackCallBack, icon:<BackHandIcon/>, status:'NA', role:'PHARMA_OMS_MANAGER'},
        {id:37, title:'Add Order', callBackMethod:addorderCallBack, icon:<AddCardIcon/>, status:'NA', role:'PHARMA_OMS_SALES, PHARMA_OMS_MANAGER'},
        {id:45, title:'Approval Mgmt', callBackMethod:accountsApprovalCallBack, icon:<TaskAltIcon/>, status:'ACCOUNTS APPROVAL', role:'PHARMA_OMS_ACCOUNTS'},
        */
        ],
        dialogueActionList: [
          
        ],
    tableView:{
      tableList:pharmaorderTransformation(tableList),
      pharmaorderList:pharmaorderList,
      actionList:[
        {title:'Edit', callBackMethod:editCallBack, icon:<EditIcon/>, status:'NA'},
        {title:'Delete', callBackMethod:initDeleteCallBack, icon:<DeleteIcon/>, status:'NA'},
        
        {id:8, title:'Manage Products', callBackMethod:manageProductsCallBack, icon:<AddLinkIcon/>, status:'Draft, REFERRED BACK', role:'DO_NO_USE'},
        {id:12, title:'Edit Order', callBackMethod:editorderCallBack, icon:<BorderColorIcon/>, status:'NA', role:'PHARMA_OMS_SALES, PHARMA_OMS_MANAGER'},
        {id:20, title:'Delete Order', callBackMethod:deleteorderCallBack, icon:<DeleteSweepIcon/>, status:'Draft, REFERRED BACK', role:'PHARMA_OMS_MANAGER'},
        {id:21, title:'Add Product', callBackMethod:addproductCallBack, icon:<PlaylistAddIcon/>, status:'NA', role:''},
        // {id:22, title:'View Order', callBackMethod:vieworderCallBack, icon:<RemoveRedEyeIcon/>, status:'Draft, PLANNING, UNDER APPROVAL, REFERED BACK,MD Approval', role:''},
        {id:23, title:'Approve Order', callBackMethod:approveorderCallBack, icon:<RuleIcon/>, status:'NA', role:'PHARMA_OMS_MD'},
        {id:26, title:'Submit Order', callBackMethod:submitorderCallBack, icon:<SendIcon/>, status:'NA', role:''},
        {id:27, title:'Refer Back Order', callBackMethod:referbackCallBack, icon:<BackHandIcon/>, status:'NA', role:'PHARMA_OMS_MANAGER'},
        {id:37, title:'Add Order', callBackMethod:addorderCallBack, icon:<AddCardIcon/>, status:'NA', role:'PHARMA_OMS_SALES, PHARMA_OMS_MANAGER'},
        {id:45, title:'Approval Mgmt', callBackMethod:accountsApprovalCallBack, icon:<TaskAltIcon/>, status:'ACCOUNTS APPROVAL', role:'PHARMA_OMS_ACCOUNTS'},
      ]
    }
  }
  
  const getPayload = ()=>{
    return payload;
  }

  useEffect(()=>{
    if (document.body.offsetWidth<500)  setView(0);
    dispatch(setViewParams({
      colsCount:{xs:12, sm:4, md:4, lg:4},
      modal:{
            
      }
      }))
  },[])

  return (
   <>
   {showloading?<PageWaiting/>:
      <Grid container direction="column">
        {userprofileInfo.rolename === "PHARMA_OMS_SALES"?
              <Grid item>
                  <Grid container direction="row" justifyContent='space-between' alignContent='center' sx={{display:'none'}}>
                      <Grid item  lg={4}>
                        <Typography variant='h4' color="primary.darker">Order List</Typography>
                      </Grid>
                      <Grid item lg={4}>
                      {showfilter ?  < PharmaorderFilterCriteria  />: <></>}
                      </Grid>
                      <Grid item lg={4}>
                        <Grid container justifyContent='flex-end' alignItems='top' >
                        {/* {showfilter?
                            <Grid item>
                              <Tooltip title="Hide filter" sx={{cursor: "pointer"}}>
                                <FilterAltOffIcon onClick={()=>{dispatch(setFilter(false))}}/>
                              </Tooltip>
                            </Grid>
                            :
                            <Grid item>
                              <Tooltip title="Show filter" sx={{cursor: "pointer"}}>
                                <FilterAltIcon onClick={()=>{dispatch(setFilter(true))}}/>
                              </Tooltip>
                            </Grid>
                            } */}
                            
                            <Grid item>
                              <Button
                                variant="contained"
                                color="primary"
                                startIcon={<AddIcon />}
                                onClick={createPharmaorder}
                                sx={{ minWidth: 0, px: 2 }}
                              >
                                Add Order
                              </Button>
                            </Grid>
                          </Grid>
                      </Grid>
                      
                  </Grid>
              </Grid>
              :<></>}
              <Grid item>
                < PharmaorderListTable 
                  payload={getPayload().tableView}
                  />
                  
              </Grid>     
      </Grid>
   }
    { showDeleteAlert?<DeleteNotification 
            id={selectedId}
            width="50%"
            setShowDeleteAlert={setShowDeleteAlert}
            deleteRecord = {deleteRecord}/>: ''
    }

    
<ManageProductsActionModal/>
<EditorderActionModal/>
<DeleteorderActionModal/>
<AddproductActionModal/>
<VieworderActionModal/>
<ApproveorderActionModal/>
<SubmitorderActionModal/>
<ReferbackActionModal/>
<AddorderActionModal/>
<AccountsApprovalActionModal/>
    </>
);


}